import React from 'react';


function Footer() {
    return (
        <h5>YQ</h5>  
    );

}

export default Footer;